import React from 'react'
import { RouteProps } from 'react-router-dom'

import { Spinner } from '@acorns/web-components'
import { datadogRum } from '@datadog/browser-rum'
import { lifecycle } from 'recompose'
import styled from 'styled-components'

import theme from 'theme'
import { sendEvent } from 'utils/web-view'

export const ELEMENT_ID = 'page_spinner'

// Note: We render a full viewport-sized container to
// center the Loader component in
const Container = styled.div<{ full?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - 80px);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background: #f5f5f5;

  ${(props) =>
    props.full &&
    `
    height: 100vh;
  `}
`

// See AFW-2466 for more information
const withWebviewEvent = lifecycle<RouteProps, {}>({
  componentDidCatch(error) {
    sendEvent({
      error: true,
      message: error.message,
      stack: error.stack,
    })

    datadogRum.addError(
      Error(
        `Webview "${this.props.location?.pathname}" encountered an error: ${error}`,
      ),
    )
  },
})

const Loading = withWebviewEvent(Spinner)

export default ({ className = '', full = true }) => (
  <Container id={ELEMENT_ID} className={className} full={full}>
    <Loading color={theme.colors.stoneLight} />
  </Container>
)

export const NonTrackedLoading = () => (
  <Container full>
    <Spinner color="grey" />
  </Container>
)
